import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDPsNewBlackjackStandUp implements ICommand
{

	public GameID : number = 0;
	public SeatNum : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.GameID = ba.readInt53();
		this.SeatNum = ba.readUint32();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint53(this.GameID);
		ba.writeUint32(this.SeatNum);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDPsNewBlackjackStandUp();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'GameID(Q)='+this.GameID+' ';
		str += 'SeatNum(D)='+this.SeatNum+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 55108;
	}

	public getCmdName() : string
	{
		return 'PsNewBlackjackStandUp';
	}

}
